module.exports = __webpack_public_path__ + "static/img/card-1.64e76e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-1.png
// module id = 5Aop
// module chunks = 0